var _class, _FilterSection;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Range } from "rc-slider";
import { Component } from "react";
import CommonStrata from "../../../Models/Definition/CommonStrata";
import Styles from "./filter-section.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let FilterSection = observer(_class = (_FilterSection = class FilterSection extends Component {
  change(filter, values) {
    runInAction(() => {
      filter.setTrait(CommonStrata.user, "minimumShown", values[0]);
      filter.setTrait(CommonStrata.user, "maximumShown", values[1]);
    });
    this.props.item.terria.currentViewer.notifyRepaintRequired();
  }
  render() {
    const item = this.props.item;
    if (!item.filters || item.filters.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: Styles.filters,
      children: item.filters.map(this.renderFilter, this)
    });
  }
  renderFilter(filter) {
    const values = [filter.minimumShown, filter.maximumShown];
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.filter,
      children: [/*#__PURE__*/_jsxs("label", {
        htmlFor: filter.property,
        children: ["Show ", filter.name, ": ", filter.minimumShown, " to ", filter.maximumShown]
      }), /*#__PURE__*/_jsx(Range, {
        value: values,
        allowCross: false,
        min: filter.minimumValue,
        max: filter.maximumValue,
        onChange: this.change.bind(this, filter)
      })]
    }, filter.property);
  }
}, _defineProperty(_FilterSection, "propTypes", {
  item: PropTypes.object.isRequired
}), _FilterSection)) || _class;
export default FilterSection;